<template>
  <el-form
    ref="form"
    :model="formData5"
    label-width="120px"
  >
    <el-form-item label="出发前公里数">
      <el-input
        readonly
        v-model="formData5.startMileage"
        placeholder
      ></el-input>
    </el-form-item>
    <el-form-item label="车辆状态">
      <el-checkbox-group v-model="formData5.checkItemConfDictIds" disabled>
        <el-checkbox
          v-for="(item, index) in start_car_check_item_list"
          :key="index"
          :label="item.confDictId"
          name="type"
          >{{ item.key }}</el-checkbox
        >
      </el-checkbox-group>
    </el-form-item>
    <el-form-item label="出发前图片">
      <uploadimgs
        :fileNameLists="fileNameListsfq"
        :limit="9"
        disabled
      ></uploadimgs>
    </el-form-item>
    <el-form-item label="出发备注">
      <el-input
        type="textarea"
        placeholder
        readonly
        v-model="formData5.startRemarks"
      ></el-input>
    </el-form-item>

    <el-form-item label="发车完成公里数">
      <el-input readonly v-model="formData5.endMileage" placeholder></el-input>
    </el-form-item>
    <el-form-item label="发车完成图片">
      <uploadimgs
        :fileNameLists="fileNameListsfh"
        :limit="9"
        disabled
      ></uploadimgs>
    </el-form-item>
    <el-form-item label="发车完成备注">
      <el-input
        type="textarea"
        placeholder
        readonly
        v-model="formData5.endRemarks"
      ></el-input>
    </el-form-item>
  </el-form>
</template>

<script>
import uploadimgs from "@/components/upLoadImgs.vue";
export default {
  components: {
    uploadimgs,
  },
  props: {
    dispatchId: {},
    isSee: {},
  },
  data() {
    return {
      //   出车/完成确认数据
      formData5: {
        endFiles: "",
        endMileage: "",
        endRemarks: "",
        startFiles: "",
        startMileage: "",
        checkItemConfDictIds: [],
        checkItems: [],
        startRemarks: "",
      },
      start_car_check_item_list: [], //卸货图片
      fileNameListsfq: [], //发车前图片
      fileNameListsfh: [],
    };
  },
  async mounted() {
    if (this.dispatchId) {
      this.wtl_getDispatchStartCarInfo();
    }
  },
  watch: {
    dispatchId: {
      handler(val) {
        if (!val) {
          return;
        }
        this.wtl_getDispatchStartCarInfo();
      },
    },
  },
  methods: {
    // 获取发车批次出车确认信息
    wtl_getDispatchStartCarInfo() {
      this.$API
        .wtl_getDispatchStartCarInfo({
          dispatchId: this.dispatchId,
        })
        .then((res) => {
          let datas = res.data.result || "";
          if (datas) {
            this.formData5 = datas;
            let checkItemConfDictIds = [];
            let arrs = datas.checkItems || [];
            arrs.forEach((item) => {
              checkItemConfDictIds.push(item.confDictId);
            });
            this.formData5.checkItemConfDictIds = checkItemConfDictIds;

            let startFiles = datas.startFiles || [];
            let endFiles = datas.endFiles || [];
            let array = [];
            let array2 = [];
            array = startFiles.map((item) => {
              let names = this.$TOOLS.getCurrentTime();
              names = new Date(names).getTime(); //获取时间戳当文件名
              let objs = {
                url: item,
                name: names,
              };
              return objs;
            });
            array2 = endFiles.map((item) => {
              let names = this.$TOOLS.getCurrentTime();
              names = new Date(names).getTime(); //获取时间戳当文件名
              let objs = {
                url: item,
                name: names,
              };
              return objs;
            });
            this.fileNameListsfq = array;
            this.fileNameListsfh = array2;
            //
          }
        });
      this.$COMAPI
        .getConfDictValDownList("start_car_check_item")
        .then((res) => {
          this.start_car_check_item_list = res || [];
        }); //出车检查项
    },
  },
};
</script>

<style lang="less" scoped>
.el-form{
    height: 100%;
    overflow: auto;
    .el-input{
        width: 300px;
    }
    .el-textarea{
        width: 600px;
    }
}
</style>